/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORTS :  SELECT PAYMENT : STYLES --------------- ++++++++++ */
export default theme =>({
  selectpayment: {
    padding: pxToEm(32),
    '& .variant-withctas': {
      '& .button': {
        minWidth: pxToEm(149),
        width: 'auto',
        padding: pxToEm(10),
        '&:last-child': {
          marginLeft: pxToEm(10)
        }
      }
    }
  }
});
